import "ditmer-embla";
import { initEmbla } from "ditmer-embla";

$(() => {
    initEmbla();
});